import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { UserCourseLessonCardKollegeUserCourseLessonFragmentDoc } from './UserCourseLessonCard/UserCourseLessonCard.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UserCourseLessonViewQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type UserCourseLessonViewQuery = { __typename?: 'Query', kollegeUser?: { __typename?: 'KollegeUser', id: string, standardCourse?: { __typename?: 'KollegeUserCourse_StandardV20250418', allLessons: Array<{ __typename?: 'KollegeUserCourseLesson', id: string, status: Types.KollegeUserCourseLessonStatus, instructor: { __typename?: 'KollegeInstructor', id: string, name: string }, courseLesson: { __typename?: 'KollegeCoursePersonalLesson', id: number, lessonOrder: number, title: string }, schedule?: { __typename?: 'KollegeSchedule', startsAt: TimeString } | null }> } | null } | null };


export const UserCourseLessonViewDocument = gql`
    query UserCourseLessonView($userId: ID!) {
  kollegeUser(id: $userId) {
    id
    standardCourse {
      allLessons {
        ...UserCourseLessonCardKollegeUserCourseLesson
      }
    }
  }
}
    ${UserCourseLessonCardKollegeUserCourseLessonFragmentDoc}`;

/**
 * __useUserCourseLessonViewQuery__
 *
 * To run a query within a Vue component, call `useUserCourseLessonViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCourseLessonViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserCourseLessonViewQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useUserCourseLessonViewQuery(variables: UserCourseLessonViewQueryVariables | VueCompositionApi.Ref<UserCourseLessonViewQueryVariables> | ReactiveFunction<UserCourseLessonViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>(UserCourseLessonViewDocument, variables, options);
}
export function useUserCourseLessonViewLazyQuery(variables?: UserCourseLessonViewQueryVariables | VueCompositionApi.Ref<UserCourseLessonViewQueryVariables> | ReactiveFunction<UserCourseLessonViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>(UserCourseLessonViewDocument, variables, options);
}
export type UserCourseLessonViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<UserCourseLessonViewQuery, UserCourseLessonViewQueryVariables>;